function buildDocumentationLink(path = "") {
    const normalizedPath = typeof path === "string"
        ? path.replace(/^\/+|\/+$/g, "")
        : "";

    if (!normalizedPath.length) {
        return "https://animotive.gitbook.io/animotive-documentation/";
    }

    return `https://animotive.gitbook.io/animotive-documentation/${normalizedPath}`;
}

const SUPPORT_EMAIL = "contact@animotive.com";

const EXTERNAL_LINKS = {
    website: {
        home: "https://animotive.com",
        pricing: "https://animotive.com/pricing",
    },
    documentation: {
        home: buildDocumentationLink(),
        gettingSetup: buildDocumentationLink("getting-setup"),
        controls: buildDocumentationLink("controls"),
        learningAnimotive: buildDocumentationLink("learning-animotive/learning-animotive"),
    },
    community: {
        discord: "https://discord.com/invite/ZJEYKVGKkK",
    },
    downloads: {
        app: "https://a1w1pvetq9.execute-api.eu-west-2.amazonaws.com/dev-proxy/api/PresignedUrl/presigned-exec-url",
    },
    media: {
        gettingStartedVideo: "https://www.youtube.com/embed/HN6WkvdP698?si=PqGW0zYb2vRmx3Y4",
    },
    contact: {
        supportEmail: SUPPORT_EMAIL,
        supportEmailHref: `mailto:${SUPPORT_EMAIL}`,
    },
    scripts: {
        hubspotForms: "https://js.hsforms.net/forms/v2.js",
        profitwell: "https://public.profitwell.com/js/profitwell.js",
    },
};

export { buildDocumentationLink };
export default EXTERNAL_LINKS;
